import type { FunctionComponent } from 'react';
import { LoadingOutlined } from '@ant-design/icons';
import { Spin, type SpinProps } from 'antd';

export const loadingIcon = <LoadingOutlined style={{ fontSize: 24 }} spin />;

export const Loading: FunctionComponent<SpinProps> = (props) => (
  <Spin {...props} indicator={loadingIcon} />
);
